<template>
  <v-row class="white--text" justify="center" align-content="center">
    <v-col cols="6">
      <v-row align="center">
        <v-col class="title text-center" cols="12">
          県内接種件数
        </v-col>
        <v-col class="headline text-center font-weight-bold" cols="12" align-self="end">
          {{String(cases).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,' )}}
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="6">
      <v-row align="center">
        <v-col class="title text-center" cols="12">
          県内接種率
        </v-col>
        <v-col class="headline text-center font-weight-bold" cols="12" align-self="end">
          {{ratio}} %
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'VaccinCounter',
  props: {
    backgroundColor: { type: [String], default: 'gray' },
    cases: { type: [Number], default: 0 },
    ratio: { type: [Number], default: 0 },
  },
  data: () => ({
  }),
  computed: {
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.pr-0 {
  padding-right: 0px;
}
</style>
